<template>
  <div class="g-body-width flex flex-col gap-4 h-full overflow-hidden">
    <div class="header text-center">
      <span class="text-19px leading-24px font-semibold">
        {{ _t('package.ai_create_card') }}
      </span>
      <Icon
        name="close-circle"
        class="cursor-pointer absolute right-4 top-3 w-22px"
        @click="emit('done')"
      ></Icon>
    </div>

    <div class="flex flex-col gap-2">
      <div
        class="ai-gen-source"
        @click="emit('aiGenByDocument')"
      >
        <Icon
          name="filetype-pdf"
          class="h-36px"
        />
        <span class="title">
          {{ _t('package.ai_create_card_by_document') }}
        </span>
      </div>
      <div
        class="ai-gen-source"
        @click="emit('aiGenByImage')"
      >
        <Icon
          name="filetype-img"
          class="h-36px"
        />
        <span class="title">{{ _t('package.ai_create_card_by_image') }}</span>
      </div>
      <div
        class="ai-gen-source"
        @click="emit('aiGenByText')"
      >
        <Icon
          name="filetype-txt"
          class="h-36px"
        />
        <span class="title">{{ _t('package.ai_create_card_by_text') }}</span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const emit = defineEmits<{
  aiGenByDocument: []
  aiGenByImage: []
  aiGenByText: []
  done: []
}>()
</script>

<style scoped>
.ai-gen-source {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px;
  background-color: white;
  border-radius: 8px;
  border: 1px solid var(--ld-border);
  cursor: pointer;
}

.ai-gen-source.selected {
  border: 1px solid var(--primary-color);
  background-color: var(--primary-100);
}

.ai-gen-source .title {
  font-size: 19px;
  font-weight: 600;
}
</style>
